import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-456a6ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = { class: "d-flex align-items-center mb-4 bg-search p-4 rounded-4" }
const _hoisted_5 = { class: "d-flex col-lg-7 align-items-center me-4" }
const _hoisted_6 = { class: "me-3 text-nowrap" }
const _hoisted_7 = ["onKeyup", "maxlength"]
const _hoisted_8 = { class: "d-flex justify-content-end" }
const _hoisted_9 = {
  key: 1,
  class: "d-lg-flex"
}
const _hoisted_10 = { class: "me-lg-4" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text-break" }
const _hoisted_15 = {
  key: 0,
  class: "ms-2 status-gray fs-8 d-flex align-items-center justify-content-center"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "color-edit" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  class: "text-center fw-bold"
}
const _hoisted_27 = {
  key: 4,
  class: "text-center fw-bold"
}
const _hoisted_28 = {
  key: 5,
  class: "d-lg-flex"
}
const _hoisted_29 = { class: "me-lg-4" }
const _hoisted_30 = { class: "d-flex align-items-center" }

import { computed, onMounted, ref, watch, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { pick } from 'lodash'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'

import Table from '@/components/table/index.vue'
import Button from '@/components/button/index.vue'
import Loading from '@/components/loading/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import DeleteUserModal from '@/views/community-admin/user-management/home/components/DeleteUserModal.vue'
import DeleteUserSuccessModal from '@/views/community-admin/user-management/home/components/DeleteUserSuccessModal.vue'

import { MAX_LENGTH_USER_NAME_SEARCH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import { USER_MANAGEMENT_STORE } from '@/store/constants'
import TotalRecords from '@/components/total-records/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

const keyword = ref('')
const sortField = ref('')
const isFilter = ref<boolean>(false)

const userDelete = ref()
const errorDelete = ref<boolean>(false)

const dataUser = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.LIST_USERS])
const dataError = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.ADMINNISTRATOR_INFOR]?.error)

watchEffect(() => {
  if (route.query) {
    sortField.value = Object.keys(pick(route.query, 'management_no', 'customer_name', 'email'))[0]
  }
})
watch(
  () => router.currentRoute.value.query,
  () => {
    if (router.currentRoute.value.path.match('/managers')?.length) {
      store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_LIST_USERS, {
        id: router.currentRoute.value.params?.id,
        params: {
          community_id: router.currentRoute.value.params?.id,
          keyword: keyword.value,
          page: router.currentRoute.value.query?.page || 1,
          page_of_number: router.currentRoute.value.query?.page_of_number || 30,
          ...router.currentRoute.value.query,
        },
      })
    }
  },
  { immediate: true }
)

onMounted(() => {
  if (Object.keys(route.query).length === 0 && router.currentRoute.value.path.match('/managers')?.length) {
    router.replace({ path: route.path, query: { management_no: 'asc' } })
  }
})

const handleSearchKeyword = () => {
  isFilter.value = true
  store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_LIST_USERS, {
    id: router.currentRoute.value.params?.id,
    params: {
      ...route.query,
      keyword: keyword.value,
      page: 1,
    },
  })
  router.replace({ path: route.path, query: { ...route.query, page: 1 } })
}

const handleDelete = (value: any) => {
  userDelete.value = value
}

const showMessageDelete = (status: boolean): void => {
  errorDelete.value = status
}

const transitDetail = (management_no: string): void => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/managers/${management_no}/edit`)
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('settings'),
    to: '',
    active: false,
  },
  {
    content: translate('adminUser'),
    to: '',
    active: true,
  },
]

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CC10listOfAdmin')), 1),
      (_unref(dataError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(translate)('CC10errorUserInfor')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('userSearch')), 1),
          _withDirectives(_createElementVNode("input", {
            onKeyup: _withKeys(handleSearchKeyword, ["enter"]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            type: "text",
            placeholder: "氏名を入力してください。",
            maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
            class: "form-control w-100"
          }, null, 40, _hoisted_7), [
            [
              _vModelText,
              keyword.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createVNode(Button, {
          title: _unref(translate)('CI10search'),
          type: 'secondary',
          size: 'small',
          onClick: handleSearchKeyword
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "managers/new",
          class: "button-router-link text-black border rounded-pill text-decoration-none fw-bold d-flex align-items-center justify-content-center bg-white shadow btn-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)('OE12button1')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(TotalRecords, {
        totalRecords: _unref(dataUser)?.total_records
      }, null, 8, ["totalRecords"]),
      (!_unref(dataUser)?.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(Pagination, {
                totalPage: _unref(dataUser)?.total_pages,
                totalDataOfPage: _unref(dataUser)?.listUsers?.length
              }, null, 8, ["totalPage", "totalDataOfPage"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_unref(dataUser)?.loading)
        ? (_openBlock(), _createBlock(Table, {
            key: 2,
            columns: [
        { field: 'management_no', name: _unref(translate)('managementNo') },
        { field: 'customer_name', name: _unref(translate)('CC10administrator') },
        { field: 'email', name: _unref(translate)('email') },
        { field: 'department_name', name: _unref(translate)('OE20belongs') },
        { field: 'last_login', name: _unref(translate)('lastLoginDate') },
        { field: 'edit', name: _unref(translate)('edit') },
        { field: 'delete', name: _unref(translate)('delete') },
      ],
            sortCells: ['management_no', 'customer_name', 'email']
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataUser)?.listUsers, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0, rowDeleted: !item.available }]),
                  key: index
                }, [
                  _createElementVNode("td", {
                    class: "cursor-pointer",
                    onClick: () => transitDetail(item?.management_no)
                  }, _toDisplayString(item.management_no), 9, _hoisted_12),
                  _createElementVNode("td", {
                    class: "d-flex align-items-center justify-content-center cursor-pointer",
                    onClick: () => transitDetail(item?.management_no)
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.family_name + ' ' + item.given_name), 1),
                    (item.is_contact_admin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(translate)('CC10contractor')), 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_13),
                  _createElementVNode("td", {
                    class: "text-break w-25 cursor-pointer",
                    onClick: () => transitDetail(item?.management_no)
                  }, _toDisplayString(item.email || '-'), 9, _hoisted_16),
                  _createElementVNode("td", {
                    class: "text-break cursor-pointer",
                    onClick: () => transitDetail(item?.management_no)
                  }, _toDisplayString(item.department_name || '-'), 9, _hoisted_17),
                  _createElementVNode("td", {
                    class: "cursor-pointer",
                    onClick: () => transitDetail(item?.management_no)
                  }, _toDisplayString(item?.last_login ? _unref(ConvertFromLocalTime)(item?.last_login) : ''), 9, _hoisted_18),
                  _createElementVNode("td", {
                    class: "text-center cursor-pointer",
                    onClick: () => transitDetail(item?.management_no)
                  }, _hoisted_21, 8, _hoisted_19),
                  _createElementVNode("td", _hoisted_22, [
                    (!item.is_contact_admin && !item?.is_current_user)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "cursor-pointer text-danger",
                          "data-bs-target": "#deleteUserModal",
                          "data-bs-toggle": "modal",
                          onClick: ($event: any) => (handleDelete(item))
                        }, _hoisted_25, 8, _hoisted_23))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["columns"]))
        : _createCommentVNode("", true),
      (_unref(dataUser)?.listUsers?.length === 0 && isFilter.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(translate)('CC40noData')), 1))
        : _createCommentVNode("", true),
      (_unref(dataUser)?.listUsers?.length === 0 && !isFilter.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(translate)('CC10noData')), 1))
        : _createCommentVNode("", true),
      (!_unref(dataUser)?.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(Pagination, {
                totalPage: _unref(dataUser)?.total_pages,
                totalDataOfPage: _unref(dataUser)?.listUsers?.length
              }, null, 8, ["totalPage", "totalDataOfPage"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DeleteUserModal, {
      userDelete: userDelete.value,
      showMessageDelete: showMessageDelete,
      totalRecord: _unref(dataUser)?.total_records
    }, null, 8, ["userDelete", "totalRecord"]),
    _createVNode(DeleteUserSuccessModal, { errorDelete: errorDelete.value }, null, 8, ["errorDelete"]),
    _createVNode(Loading, {
      loading: _unref(dataUser)?.loading
    }, null, 8, ["loading"])
  ], 64))
}
}

})